import React from "react";
import {useTranslation} from "react-i18next";

export declare type BannerProps = {
    image: string;
    title: string;
    altText?: string;
    textColor?: string;
}

const TopBanner: React.FC<BannerProps> = (props: BannerProps) => {
    const { t } = useTranslation();
    return (
        <>
            <div className={`subpage-banner bg-cover relative 
            ${props.textColor ? 'text-white' : 'text-secondary'}
            font-primary`}>
                <img src={props.image} alt={props.altText} className="w-full align-middle h-96 object-cover object-center lg:h-auto"/>
                <div className="banner-description-v2 container mx-auto absolute right-0 left-0 z-10">
                    <h2 className="text-3xl md:text-4xl lg:text-6xl xl:text-100 font-bold relative font-primary">{t(props.title)}</h2>
                </div>
                <div className="overlay absolute bg-overlay-0"></div>
            </div>
        </>
    )
}

export default TopBanner;